import { jsx as _jsx } from "react/jsx-runtime";
import { RechartsSeriesTooltipContent } from '@web/components/layout/RechartsItems/RechartsSeriesTooltipContent';
import { orderTooltipPayload } from '@web/components/layout/RechartsItems/rechartsTooltipPayload';
export function AppsMultiSeriesBarTooltip(_a) {
    var _b, _c;
    var active = _a.active, payload = _a.payload, label = _a.label, formatValue = _a.formatValue, seriesOrder = _a.seriesOrder, seriesLabelFormatter = _a.seriesLabelFormatter, selectTooltipPayload = _a.selectTooltipPayload;
    if (!active || !(payload === null || payload === void 0 ? void 0 : payload.length)) {
        return null;
    }
    var ordered = orderTooltipPayload(payload, seriesOrder);
    var dataRow = ((_c = (_b = ordered[0]) === null || _b === void 0 ? void 0 : _b.payload) !== null && _c !== void 0 ? _c : {});
    var visible = selectTooltipPayload
        ? selectTooltipPayload({ row: dataRow, payload: ordered })
        : ordered;
    if (!visible.length) {
        return null;
    }
    var allSeriesZero = visible.every(function (entry) { var _a; return Number((_a = entry.value) !== null && _a !== void 0 ? _a : 0) === 0; });
    if (allSeriesZero) {
        return null;
    }
    return (_jsx(RechartsSeriesTooltipContent, { label: label, rows: visible, formatValue: formatValue, seriesLabelFormatter: seriesLabelFormatter }));
}
